import { SignUp } from '@clerk/react';

export function RegisterPage(): JSX.Element {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f2f2f2' }}>
      <SignUp routing="path" path="/register" />
    </div>
  );
}
